// WebsiteLogo
import aladin from './logo/aladin.png'
import kyobo from './logo/kyobo.png'
import yes24 from './logo/yes24.png'
import appStore from './logo/apple-appstore.png'
import googleChrome from './logo/google-chrome.png'
import naverSquare from './logo/naver-square.png'
import amazon from './logo/amazon.png'

import booksitout from './logo/booksitout.png'
import purrfitTracker from './logo/purrfitTracker.png'
import substrack from './logo/substrack.png'
import featuredDays from './logo/featureddaysicon.png'
import pianoMan from './logo/pianoman.png'
import simplifiedGoogleTask from './logo/simplified-google-task.png'
import toss from './logo/toss.png'
import lostThings from './logo/lostThings.png'

// Placeholder
import user from './placeholder/user.png'
import userLoading from './placeholder/user-loading.png'
import bookCover from './placeholder/default-book-cover.png'
import bookCoverLoading from './placeholder/default-book-cover-loading.png'
import searchCoverPlaceholder from './placeholder/search-cover-placeholder.png'
import libraryLoading from './placeholder/square-loading.png'
import tips from './placeholder/tips.png'
import tipsLoading from './placeholder/tips-loading.png'

// Illustration
import relax from './illustration/relax.svg'

// Login
import appleLogin from './login-button/small-apple.png'
import appleLoginDark from './login-button/small-apple-black.png'
import facebookLogin from './login-button/small-facebook.png'
import googleLogin from './login-button/small-google.png'
import kakaoLogin from './login-button/small-kakao.png'
import naverLogin from './login-button/small-naver.png'
import samsungLogin from './login-button/small-samsung.png'
import twitterLogin from './login-button/small-twitter.png'

// Statistics
import streak from './statistics/streak.png'
import goal from './statistics/goal.png'
import goalComplete from './statistics/goal-complete.png'
import time from './statistics/time.png'
import average from './statistics/simple-chart.png'
import averageReadingDays from './statistics/average2.png'
import book from './statistics/book-overlap.png'
import star from './statistics/star.png'
import longestDay from './statistics/bookworm.png'
import page from './statistics/page.png'

// StatisticsCategory
import others from './book-classifications/categories/others.png'
import philosophy from './book-classifications/categories/philosophy.png'
import religion from './book-classifications/categories/religion.png'
import socialScience from './book-classifications/categories/social-science.png'
import naturalScience from './book-classifications/categories/natural-science.png'
import technology from './book-classifications/categories/technology.png'
import art from './book-classifications/categories/art.png'
import language from './book-classifications/categories/language.png'
import literature from './book-classifications/categories/literature.png'
import history from './book-classifications/categories/history.png'
import question from './book-classifications/categories/unknown.png'

// Classifications
import publisher from './book-classifications/publisher.png'
import calendar from './book-classifications/calendar.svg'

// Membership
import appleWallet from './membership/apple-wallet-korean-small.png'

const BooksitoutImages = {
    WebsiteLogo: {
        aladin: aladin,
        kyobo: kyobo,
        yes24: yes24,
        amazon: amazon,

        appStore: appStore,
        googleChrome: googleChrome,

        naver: naverSquare,

        booksitout: booksitout,
        purrfitTracker: purrfitTracker,
        substrack: substrack,
        featuredDays: featuredDays,
        pianoman: pianoMan,
        simplifiedGoogleTask: simplifiedGoogleTask,
        toss: toss,
        lostThings: lostThings,
    },

    Placeholder: {
        user: user,
        userLoading: userLoading,
        bookCover: bookCover,
        bookCoverLoading: bookCoverLoading,
        libraryLoading: libraryLoading,
        tips: tips,
        tipsLoading: tipsLoading,
        searchCover: searchCoverPlaceholder,
    },

    Illustration: {
        relax: relax,
    },

    LoginButton: {
        google: googleLogin,
        kakao: kakaoLogin,
        naver: naverLogin,

        apple: appleLogin,
        appleDark: appleLoginDark,
        facebook: facebookLogin,
        samsung: samsungLogin,
        twitter: twitterLogin,
    },

    Statistics: {
        streak: streak,
        goal: goal,
        goalComplete: goalComplete,
        time: time,
        average: average,
        book: book,
        star: star,
        longestDay: longestDay,
        page: page,
        averageReadingDays: averageReadingDays,
    },

    StatisticsCategory: {
        others: others,
        philosophy: philosophy,
        religion: religion,
        socialScience: socialScience,
        naturalScience: naturalScience,
        technology: technology,
        art: art,
        language: language,
        literature: literature,
        history: history,
        question: question,
    },

    Classifications: {
        publisher: publisher,
        publishedYear: calendar,
    },

    Membership: {
        appleWallet: appleWallet
    }
}

export default BooksitoutImages